import { useMutation } from 'react-query';
import Customers from '../../services/Customers';

export const useCustomerNoShow = () => useMutation((customerId: number) => Customers.noShow(customerId));
